module.exports = __webpack_public_path__ + "static/media/Inter-Light.9d57b05c.woff";